import {runWithAdal} from 'react-adal';
import {authContext} from './adal/adalConfig';

const DO_NOT_LOGIN = true;

runWithAdal(authContext, ()=>{
    require('./indexApp.js');
}, DO_NOT_LOGIN)


// WEBPACK FOOTER //
// ./src/index.js